module.exports = __webpack_public_path__ + "img/Platine_0006_7.2efc7f2d.png";